<template>
  <div class="membresias">
    <v-container>
      <v-row>
        <v-col>
          <v-breadcrumbs :items="items" :divider="'|'" class="py-0 pl-0">
            <template v-slot:item="props">
              <v-breadcrumbs-item :to="props.item.to" :class="[props.item.disabled && 'disabled']">
                <span style="color: black;">{{ props.item.text }}</span>
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="11">
          <div class="text-center">
            <h1 class="PTSerif" style="font-size: 20px;">Membresías</h1>
          </div>
          <div class="text-left">
            <p
              style="max-width: 582px; white-space: pre-wrap"
              class="d-block mx-auto my-3"
            >{{membresias.descripcionGeneral}}</p>
          </div>
        </v-col>
      </v-row>

      <v-row justify="center">
        <!-- <v-col cols="2"></v-col> -->
        <v-col cols="11" md="10">
          <v-row>
            <v-col cols="12" md="4" class="text-left text-md-center">
              <span>
                <v-avatar color="#56604D" size="24" class="mr-3">
                  <v-icon color="white" size="18">mdi-check</v-icon>
                </v-avatar>
                <span class="membresias-texts">{{membresias.encabezadoMensual}}</span>
              </span>
            </v-col>

            <v-col cols="12" md="4" class="text-left text-md-center">
              <span class="mx-md-12">
                <v-avatar color="#56604D" size="24" class="mr-3">
                  <v-icon color="white" size="18">mdi-check</v-icon>
                </v-avatar>
                <span class="membresias-texts">{{membresias.encabezadoAnual}}</span>
              </span>
            </v-col>

            <v-col cols="12" md="4" class="text-left text-md-center">
              <span>
                <v-avatar color="#56604D" size="24" class="mr-3">
                  <v-icon color="white" size="18">mdi-check</v-icon>
                </v-avatar>
                <span class="membresias-texts">{{membresias.encabezadoTemporada}}</span>
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row justify="center">
        <!-- <v-col cols="2"></v-col> -->
        <v-col cols="11" md="10">
          <v-row>
            <!-- *******inicia columna1******* -->

            <v-col cols="12" md="4" class="text-center">
              <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+membresias.imagenMensual.path" height="250"></v-img>
              <!-- desk -->
              <!-- ****** inicia span oculto de md para abajo****** -->
              <span
                class="d-none d-md-block my-6"
                style="font-size: 20px; font-weight: 700;"
              >Mensual</span>
              <!-- ******* termina span oculto de md para abajo****** -->

              <!-- *****inicia info oculto de md para abajo***** -->
              <div class="d-none d-md-block">
                <span class="d-block my-6" style="font-weight: 700;">Incluye</span>

                <span class="d-block" style="white-space: pre-wrap">
                  {{membresias.contenidoMensual}}
                </span>

                <span
                  class="d-block my-9"
                  style="font-size: 20px; font-weight: 100;"
                >Solicita tu cotización</span>

                <!-- <router-link to="/contacto" style="text-decoration: none;">
                  <v-btn color="#B4613D" elevation="0" rounded dark width="100%">Contáctanos</v-btn>
                </router-link> -->
              </div>
              <!-- *****termina info oculto de md para abajo***** -->
              <!-- desk -->

              <!-- mobile -->
              <!-- *****inicia btn oculto de md para arriba**** -->
              <v-btn
                color="#fff"
                width="100%"
                tile
                elevation="0"
                class="d-md-none my-6 pb-12"
                :ripple="false"
                style="border-bottom: 2px solid #E4CFA6;"
                @click="infoExpand = !infoExpand"
              >
                <span style="color:black; font-size:20px;" class="PTSerif">Mensual</span>
                <v-icon
                  color="black"
                  v-bind:class="{'rotate' : infoExpand}"
                  style="position:absolute; right:0;"
                >mdi-chevron-down</v-icon>
              </v-btn>
              <!-- *****termina btn oculto de md para arriba***** -->

              <v-expand-transition>
                <div class="d-md-none" v-if="infoExpand">
                  <span class="d-block py-6" style="font-weight: 700;">Incluye</span>

                  <span class="d-block" style="white-space: pre-wrap">{{membresias.contenidoMensual}}</span>

                  <span
                    class="d-block py-9"
                    style="font-size: 20px; font-weight: 100;"
                  >Solicita tu cotización</span>

                  <router-link to="/contacto" style="text-decoration: none;">
                    <v-btn color="#B4613D" elevation="0" rounded dark width="100%">Contáctanos</v-btn>
                  </router-link>
                </div>
              </v-expand-transition>
              <!-- mobile -->
            </v-col>
            <!-- *******termina columna1******* -->

            <!-- *******inicia columna2******* -->
            <v-col cols="12" md="4" class="text-center">
              <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+membresias.imagenAnual.path" height="250"></v-img>
              <!-- desk -->
              <!-- ****** inicia span oculto de md para abajo****** -->
              <span class="d-none d-md-block my-6" style="font-size: 20px; font-weight: 700;">Anual</span>
              <!-- ******* termina span oculto de md para abajo****** -->

              <!-- *****inicia info oculto de md para abajo***** -->
              <div class="d-none d-md-block">
                <span class="d-block my-6" style="font-weight: 700;">Incluye</span>

                <span class="d-block" style="white-space: pre-wrap;">{{membresias.contenidoAnual}}</span>

                <span
                  class="d-block my-9"
                  style="font-size: 20px; font-weight: 100;"
                >Solicita tu cotización</span>

                <router-link to="/contacto" style="text-decoration: none;">
                  <v-btn color="#B4613D" elevation="0" rounded dark width="100%">Contáctanos</v-btn>
                </router-link>
              </div>
              <!-- *****termina info oculto de md para abajo***** -->
              <!-- desk -->

              <!-- mobile -->
              <!-- *****inicia btn oculto de md para arriba**** -->
              <v-btn
                color="#fff"
                width="100%"
                tile
                elevation="0"
                class="d-md-none my-6 pb-12"
                :ripple="false"
                style="border-bottom: 2px solid #E4CFA6;"
                @click="infoExpand2 = !infoExpand2"
              >
                <span style="color:black; font-size:20px;" class="PTSerif">Anual</span>
                <v-icon
                  color="black"
                  v-bind:class="{'rotate' : infoExpand2}"
                  style="position:absolute; right:0;"
                >mdi-chevron-down</v-icon>
              </v-btn>
              <!-- *****termina btn oculto de md para arriba***** -->

              <v-expand-transition>
                <div class="d-md-none" v-if="infoExpand2">
                  <span class="d-block py-6" style="font-weight: 700;">Incluye</span>

                  <span class="d-block" style="white-space: pre-wrap;">{{membresias.contenidoAnual}}</span>

                  <span
                    class="d-block py-9"
                    style="font-size: 20px; font-weight: 100;"
                  >Solicita tu cotización</span>

                  <router-link to="/contacto" style="text-decoration: none;">
                    <v-btn color="#B4613D" elevation="0" rounded dark width="100%">Contáctanos</v-btn>
                  </router-link>
                </div>
              </v-expand-transition>
            </v-col>
            <!-- *******termina columna2******* -->

            <!-- *******inicia columna3******* -->
            <v-col cols="12" md="4" class="text-center">
              <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+membresias.imagenTemporada.path" height="250"></v-img>
              <!-- desk -->
              <!-- ****** inicia span oculto de md para abajo****** -->
              <span
                class="d-none d-md-block my-6"
                style="font-size: 20px; font-weight: 700;"
              >Flor de Temporada</span>
              <!-- ******* termina span oculto de md para abajo****** -->

              <!-- *****inicia info oculto de md para abajo***** -->
              <div class="d-none d-md-block">
                <span class="d-block my-6" style="font-weight: 700;">Incluye</span>

                <span class="d-block" style="white-space: pre-wrap;">{{membresias.contenidoTemporada}}</span>

                <span
                  class="d-block my-9"
                  style="font-size: 20px; font-weight: 100;"
                >Solicita tu cotización</span>

                <!-- <router-link to="/contacto" style="text-decoration: none;">
                  <v-btn color="#B4613D" elevation="0" rounded dark width="100%">Contáctanos</v-btn>
                </router-link> -->
              </div>
              <!-- desk -->

              <!-- mobile -->
              <!-- *****inicia btn oculto de md para arriba**** -->
              <v-btn
                color="#fff"
                width="100%"
                tile
                elevation="0"
                class="d-md-none my-6 pb-12"
                :ripple="false"
                style="border-bottom: 2px solid #E4CFA6;"
                @click="infoExpand3 = !infoExpand3"
              >
                <span style="color:black; font-size:20px;" class="PTSerif">Flor de Temporada</span>
                <v-icon
                  color="black"
                  v-bind:class="{'rotate' : infoExpand3}"
                  style="position:absolute; right:0;"
                >mdi-chevron-down</v-icon>
              </v-btn>
              <!-- *****termina btn oculto de md para arriba***** -->
              <v-expand-transition>
                <div class="d-md-none" v-if="infoExpand3">
                  <span class="d-block py-6" style="font-weight: 700;">Incluye</span>

                  <span class="d-block" style="white-space: pre-wrap;">{{membresias.contenidoAnual}}</span>

                  <span
                    class="d-block py-9"
                    style="font-size: 20px; font-weight: 100;"
                  >Solicita tu cotización</span>

                  <router-link to="/contacto" style="text-decoration: none;">
                    <v-btn color="#B4613D" elevation="0" rounded dark width="100%">Contáctanos</v-btn>
                  </router-link>
                </div>
              </v-expand-transition>
            </v-col>
            <!-- ********termina columna3******* -->
          </v-row>
        </v-col>
      </v-row>

      <v-row align="center" class="pt-6">
        <v-col cols="12" md="4" offset="0"  offset-md="1" order="1" order-md="0">
         <div class="text-center text-md-left">
              <span class="PTSerif" style="font-size: 20px;">{{membresias.tituloDescripcion1}}</span>
         </div>
          <div class="my-3" v-html="membresias.descripcion1">

          </div>
        </v-col>
        <v-col class="px-0 px-md-3" cols="12" md="6" offset="0" offset-md="1" order="0" order-md="1">
          <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+membresias.imagen1.path"></v-img>
        </v-col>
      </v-row>

      <v-row align="center" class="py-6">
        <v-col cols="12" md="6" class="px-0 px-md-3">
          <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+membresias.imagen2.path"></v-img>
        </v-col>
        <v-col cols="12" md="4" class="margin-left-membresias">
          <div class="text-center text-md-left">
              <span class="PTSerif" style="font-size: 20px;">{{membresias.tituloDescripcion2}}</span>
          </div>
          <div class="my-3" v-html="membresias.descripcion2">

          </div>
        </v-col>
      </v-row>

      <v-row align="center" class="pb-8">
        <v-col cols="12" md="4" offset="0"  offset-md="1" order="1" order-md="0">
          <div class="text-center text-md-left">
              <span class="PTSerif" style="font-size: 20px;">{{membresias.tituloDescripcion3}}</span>
          </div>
          <div class="my-3" v-html="membresias.descripcion3">

          </div>

          <router-link to="/contacto" style="text-decoration: none;">
            <v-btn color="#B4613D" rounded dark class="membresias-contactanos-btn" elevation="0">
              <span style="font-weight: 700">CONTÁCTANOS</span>
            </v-btn>
          </router-link>
        </v-col>
        <v-col cols="12" md="6" offset="0" offset-md="1" order="0" order-md="1">
          <div class="d-none d-md-block">
              <v-img :src="'https://flordeazaharcms.actstudio.xyz/'+membresias.imagen3.path"></v-img>
          </div>
          <div class="d-block d-md-none">
              <v-carousel height="auto" :show-arrows="false" :hide-delimiter-background="true">
                  <v-carousel-item>
                      <v-img src="../assets/img/plan-personalizado.jpg"></v-img>
                  </v-carousel-item>
                  <v-carousel-item>
                      <v-img src="../assets/img/plan-personalizado.jpg"></v-img>
                  </v-carousel-item>
              </v-carousel>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          text: "Inicio",
          disabled: false,
          href: "/"
        },
        {
          text: "Membresías",
          disabled: true
        }
      ], //termina items
      //v-expand
      infoExpand: false,
      infoExpand2: false,
      infoExpand3: false,
      membresias: {
        imagenMensual: {
            path: ""
        },
        imagenAnual: {
            path: ""
        },
        imagenTemporada: {
            path: ""
        },
        imagen1: {
          path: ""
        },
        imagen2: {
          path: ""
        },
        imagen3: {
          path: ""
        },
        
      }
    };
  },
  created: function() {
    fetch(
      "https://flordeazaharcms.actstudio.xyz/api/singletons/get/Membresias?token=bd38a532024ddfd195a5fdefd8eb98"
    )
      .then(res => res.json())
      .then(res => (this.membresias = res));
  }
};
</script>